import React from 'react';
import PropTypes from 'prop-types';

import Checkbox from 'zignal-landscape/lib/Checkbox';
import Label from 'zignal-landscape/lib/Label';
import Select from 'zignal-landscape/lib/Select';

import styles from './WorkbenchFieldCampaignSelector.css';
import { truncateString } from './helpers';
import find from 'lodash/find';

let counter = -1;
function getCheckboxId() {
  counter++;
  return `checkbox_id_${counter}`;
}


function WorkbenchFieldCampaignSelector(props) {
  const {
    allCampaigns,
    campaignIds, isAvailableToAllCampaigns,
    onChangeCheckbox, onChangeSelect,
  } = props;

  let renderedSelect;
  if (isAvailableToAllCampaigns) {
    // a read-only listing of all Campaigns
    const titles = allCampaigns.map((campaign) => campaign.title);
    const truncated = truncateString(titles.join(', '), 96);
    renderedSelect = (<div className={styles.selectShareAll}>
      {truncated}
    </div>);
  }
  else {
    // a multi-<select /> for Campaigns
    const options = allCampaigns.map((campaign) => {
      return {
        label: campaign.title,
        value: campaign.id,
      };
    });
    const selectValue = campaignIds.map((c) => find(options, {value: c}));

    renderedSelect = (<div className={styles.selectControl}>
      <Select
        isMulti
        value={selectValue}
        onChange={onChangeSelect}
        placeholder="Select Workspace(s)"
        options={options}
      />
    </div>);
  }

  // for `<input id name />, `<label for />`
  const checkboxId = getCheckboxId();

  return (<div>
    <div className={styles.checkboxControl}>
      <Checkbox
        id={checkboxId}
        name={checkboxId}
        checked={isAvailableToAllCampaigns}
        onChange={onChangeCheckbox}
      />
      <Label
        htmlFor={checkboxId}
        inline
      >
        Share with all
      </Label>
    </div>
    {renderedSelect}
  </div>);
}

WorkbenchFieldCampaignSelector.propTypes = {
  allCampaigns: PropTypes.array.isRequired,
  campaignIds: PropTypes.array.isRequired,
  isAvailableToAllCampaigns: PropTypes.bool.isRequired,
  onChangeCheckbox: PropTypes.func.isRequired,
  onChangeSelect: PropTypes.func.isRequired,
};

export default WorkbenchFieldCampaignSelector;
